import { render, staticRenderFns } from "./pageWithNav.vue?vue&type=template&id=6a321c42&scoped=true&"
import script from "./pageWithNav.vue?vue&type=script&lang=js&"
export * from "./pageWithNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a321c42",
  null
  
)

export default component.exports